import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchInitialData } from '../actions/entities';

class App extends Component {
    static propTypes = {
        fetchInitialData: PropTypes.func.isRequired,
    }

    componentDidMount() {
        if (this.props.loggedIn)
            this.props.fetchInitialData();
    }

    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { loggedIn } = state.environment;

    return {
        loggedIn,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ fetchInitialData }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./scripts/containers/App.jsx